module.exports = __webpack_public_path__ + "img/logo_be_vallet_pnud.4a6d6ba9.png";